import { Link } from "react-router-dom";

import { ERoomIcon, Room } from "../../AppDataType";
import RoomIcon from "../RoomIcon/RoomIcon";
import useDataContext from "../../providers/DataProvider/useDataContext";

interface Props {
    room: Room
}

const RoomCard: React.FC<Props> = ({ room }) => {
    const { data } = useDataContext();

    return (
        <Link to={ data.pages.roomsPage.route }
              state={{ roomIndex: room.index }}
              aria-label="more-info-link"
              className="flex justify-center h-full">
            <article aria-label="room-card"
                     className="flex flex-col justify-between gap-3 rounded-xl w-[550px]
                              bg-first-solid text-fifth-solid overflow-hidden 
                                cursor-pointer transition-shadow duration-500 ease-out
                                hover:shadow-first-solid">
                <figure className="overflow-hidden">
                    <img src={room.images.cardImage.src}
                         alt={room.images.cardImage.alt}
                         className="transition-transform duration-500 ease-out hover:scale-110"
                         loading="lazy"/>
                </figure>

                <h4 className="text-2xl font-bold text-center py-2 lg:py-4">
                    { room.name }
                </h4>

                <ul role="list" 
                    aria-label="room-icons"
                    className="grid grid-cols-3 gap-y-4 gap-x-2 lg:gap-y-6 px-2 lg:px-4">
                {
                    room.icons.map((roomIcon, index) => (
                        <li role="listitem" 
                            key={index}
                            className="flex flex-col items-center text-center gap-2">
                            <RoomIcon icon={roomIcon.icon as ERoomIcon}/>
                            <span className="text-base">
                                {roomIcon.text}
                            </span>
                        </li>
                    ))
                }
                </ul>

                <button className="bg-second-solid text-base px-5 py-3
                                     transition-colors duration-500 ease-out
                                     hover:bg-third-solid hover:text-first-solid">
                    { data.components.roomCard.moreInfoButton }
                </button>
            </article>
        </Link>
    )
};

export default RoomCard;
